import { gsap } from "gsap";

const ChangeVoiceVideo = () => {
	const block = document.querySelectorAll(".change-voice-video");
	if (!block) {
		return;
	}
	block.forEach((el) => {
		const thisBlock = el;
		const videoWrap = thisBlock.querySelector(".change-voice-video__frame");
		const video = thisBlock.querySelector(".change-voice-video__frame-el");
		const track = thisBlock.querySelector(".change-voice-video__track");
		const navControls = thisBlock.querySelectorAll(".change-voice-video__nav-control");
		const control = thisBlock.querySelector(".change-voice-video__control");
		let mm = gsap.matchMedia();

		const playFrame = () => {
			track.load();
			video.pause();
			track.currentTime = video.currentTime;
			track.play();
			video.play();
		};

		videoWrap.addEventListener("click", (e) => {
			if (thisBlock.classList.contains("playing")) {
				thisBlock.classList.remove("playing");
				track.pause();
			} else {
				thisBlock.classList.add("playing");
				playFrame();
			}
		});

		navControls.forEach(button => {
			button.addEventListener("click", (e) => {
				const targetSrc = e.target.getAttribute("data-voice");

				if (!e.target.classList.contains("active")) {
					track.setAttribute("src", targetSrc);

					navControls.forEach(item => {
						item.classList.remove("active");
					});
					e.target.classList.add("active");
					thisBlock.classList.add("playing");
					playFrame();
				}
			});
		});

		mm.add("(min-width: 1024px)", () => {
			const moveCursor = function (event) {
				gsap.to(control, {
					css: {
						left: event.offsetX,
						top: event.offsetY,
					},
					duration: 0.4
				});
			};

			videoWrap.addEventListener("mouseover", (e) => {
				document.addEventListener("mousemove", moveCursor, false);
			});

			videoWrap.addEventListener("mouseleave", (e) => {
				document.removeEventListener("mousemove", moveCursor, false);
				gsap.to(control, { css: { left: "50%", top: "50%" }, duration: 0.5 });
			});
		});
	});
};

export default ChangeVoiceVideo;
